import { render, staticRenderFns } from "./PartnerWithdrawal.vue?vue&type=template&id=8501aefe&scoped=true&"
import script from "./PartnerWithdrawal.vue?vue&type=script&lang=js&"
export * from "./PartnerWithdrawal.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWithdrawal.vue?vue&type=style&index=0&id=8501aefe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8501aefe",
  null
  
)

export default component.exports